import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import permission from "../../config/permission";
import API from "../../config/api";

class Sidebar extends Component {
  constructor(props) {
      super(props);
      this.state = {
        nb_click: 0,
        pathname: "/",
        // permission: [],
        allRoutes: [],
        route_path: ''
      }
    }

    componentDidMount() {
     setInterval(() => {
      if (this.state.pathname !== window.location.pathname) {
        
          this.setState({pathname: window.location.pathname});
      }

     }, 100);
     this.getUserRole();

    
     this.checkPermission();
     this.getAllRole();

     this.setState({allRoutes: permission});
     this.getRouthPath();
    }

    getAllRole = async () => {
      try {
        // let query = `category_id=${this.state.category_id}`
        let results = await API.getAllRole();
  
        let data = results.data;
        {data.map(per => (
          this.setState(permission= per.permission )
          // per.permission.map(role => (
          //   console.log(role.name)
          // ))
  
        ))}
        // this.setState({ 
        //   categories : data, 
        //   thumbnail: data.thumbnail_url
        // });
  
      } catch (error) {
        console.log(error)
      }
    }

    checkPermission() {
      let pathname = window.location.pathname;
      // {permission.map(per => (
      //   console.log(per.name)


      // ))}
      
    }

    getUserRole = async () => {
      try {
        // let query = `category_id=${this.state.category_id}`
        let results = await API.getUserRole();

        let permission = JSON.parse(results.data.permission);

        permission.forEach(p => {
          if (window.location.pathname == p.route) {
            if (!p.allow) {
              window.location.pathname = "404"
            }
            
        }
        })

        this.setState({allRoutes: permission});
  
      } catch (error) {
        console.log(error)
      }
    }

    getRouthPath() {
      permission.map(per => {
        if(per.children) {
          per.children.map(child => {

            this.state.route_path = `/+${child.route}`;
            this.setState({})
          })
        } else {
          this.state.route_path = per.route;
          this.setState({})
        }
      })
      
    }

    render() {
      return (
      <aside className="sidebar sidebar-icons-right sidebar-icons-boxed sidebar-expand-lg">
      <header className="sidebar-header">
        <Link className="logo-icon" to="#">
            {/* <img src={require('../../assets/assets_theme/img/logo-icon-light.png')} alt="logo icon" /> */}
        </Link>
        <span className="logo">
            {/* <Link to=""><img src={require('../../assets/assets_theme/img/logo-light.png')} alt="logo" /></Link> */}
            UBT Cambodia
        </span>
        {/* <span className="sidebar-toggle-fold"></span> */}
      </header>
     

      <nav className="sidebar-navigation">
        <ul className="menu">

          {/* <li className="menu-category">Preview</li>route.parameter */}

          {
            this.state.allRoutes.map(route => {
              if (!route.allow) {
                return <div/>
              }
              return <li className={`menu-item ${this.state.pathname === route.parameter[0] || this.state.pathname === route.parameter[1] || this.state.pathname === route.parameter[2] 
                || this.state.pathname === route.parameter[3] || this.state.pathname === route.parameter[4] || this.state.pathname === route.parameter[5] || this.state.pathname === route.parameter[6]
                || this.state.pathname === route.parameter[7] || this.state.pathname === route.parameter[8] || this.state.pathname === route.parameter[9]? "active" : ""} `}>
                <Link className="menu-link" to={route.route}>
                  <span className={`icon ${route.icon}`}></span>
                  <span className="title">{route.name}</span>
                  {route.children && <span className="arrow"></span>}
                </Link>
                {
                  route.children && <ul className="menu-submenu">
                  {
                    route.children.map(child => {
                      return <li className={`menu-item ${this.state.pathname === child.route ? "active" : ""} `}>
                        <Link className="menu-link" to={child.route} >
                          <span className="dot"></span>
                          <span className="title">{child.name}</span>
                        </Link>
                      </li>
                    })
                  }  
                  
                  </ul>
                }
              </li>
            })
          }

          {/* <li className={`menu-item ${this.state.pathname === "/"? "active" : ""} `}>
            <Link className="menu-link" to="/">
              <span className="icon fa fa-home"></span>
              <span className="title">Dashboard</span>
            </Link>
          </li>

          <li className={`menu-item ${this.state.pathname=== "/userindex" || this.state.pathname=== "/useredit" || this.state.pathname=== "/userview" || this.state.pathname=== "/usernew" ? "active" : ""} `}>
            <Link className="menu-link" to="/userindex">
              <span className="icon fa fa-users"></span>
              <span className="title">User</span>
            </Link>
          </li>
          
          <li class={`menu-item ${this.state.pathname === "/questionindex" || this.state.pathname=== "/questionedit" || this.state.pathname=== "/questionview" ? "active" : ""} `}>
            <Link className="menu-link" to="/questionindex">
              <span className="icon fa fa-question"></span>
              <span className="title">Questions</span>
            </Link>
          </li>
          <li class={`menu-item ${this.state.pathname === "/categoryindex" || this.state.pathname=== "/categoryedit" || this.state.pathname=== "/categoryview" || this.state.pathname=== "/categorynew"  ? "active" : ""} `}>
            <Link className="menu-link" to="/categoryindex">
              <span className="icon fa fa fa-file-text-o"></span>
              <span className="title">Category</span>
            </Link>
          </li>
          <li class={`menu-item ${this.state.pathname === "/blindtestindex" || this.state.pathname=== "/blindtestedit" || this.state.pathname=== "/blindtestview" || this.state.pathname=== "/blindtestnew"  ? "active" : ""} `}>
            <Link className="menu-link" to="/blindtestindex">
              <span className="icon fa fa-eye"></span>
              <span className="title">Blind Test</span>
            </Link>
          </li>

          <li class={`menu-item ${this.state.pathname === "/folderindex" || this.state.pathname=== "/folderedit" || this.state.pathname=== "/folderview" || this.state.pathname=== "/foldernew"  ? "active" : ""} `}>
            <Link className="menu-link" to="/folderindex">
              <span className="icon fa fa-folder-open-o"></span>
              <span className="title">Folder</span>
            </Link>
          </li>
          <li class={`menu-item ${this.state.pathname === "/classindex" || this.state.pathname=== "/classedit" || this.state.pathname=== "/classedit" || this.state.pathname=== "/classnew"  ? "active" : ""} `}>
            <Link className="menu-link" to="/classindex">
              <span className="icon fa fas fa-book"></span>
              <span className="title">Class</span>
            </Link>
          </li>

          <li className={`menu-item ${ this.state.pathname.includes('role') || this.state.pathname.includes('permission') ? "active" : ""} `}>
            <Link className="menu-link" to="#">
              <span className="icon fa fa-user-times"></span>
              <span className="title">User Management</span>
              <span className="arrow"></span>
            </Link>

            <ul className="menu-submenu">
              <li className={`menu-item ${this.state.pathname.includes('/role') ? "active" : ""} `}>
                <Link className="menu-link" to="/role" >
                  <span className="dot"></span>
                  <span className="title">Role & Permission</span>
                </Link>
              </li>
              
            </ul>
          </li>

          <li className={`menu-item ${ this.state.pathname.includes('termandcondition') || this.state.pathname.includes('aboutus') ? "active" : ""} `}>
            <Link className="menu-link" to="#">
              <span className="icon ti-settings"></span>
              <span className="title">Setting</span>
              <span className="arrow"></span>
            </Link>

            <ul className="menu-submenu">
              <li className={`menu-item ${this.state.pathname.includes('/termandcondition') ? "active" : ""} `}>
                <Link className="menu-link" to="/termandcondition" >
                  <span className="dot"></span>
                  <span className="title">Terms and Conditions</span>
                </Link>
              </li>
              <li className={`menu-item ${this.state.pathname.includes('/aboutus') ? "active" : ""} `}>
                <Link className="menu-link" to="/aboutus" >
                  <span className="dot"></span>
                  <span className="title">About Us</span>
                </Link>
              </li>
            </ul>
          </li> */}

        </ul>
        
      </nav>
    </aside>
    );
    }
}



export default Sidebar